export default function pagesReducer(state = {
  pageNameTaken: false,
  pages: [],
  bluPages: [],
  pagesMeta: {},
  fetching: false,
  fetched: false,
  errors: {}
}, action) {
  switch (action.type) {
    case 'GET_PAGES_PENDING': {
      return {...state, fetching: true, fetched: false}
    }
    case 'GET_PAGES_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        pages: action.payLoad,
      }
    }
    case 'GET_PAGE_PENDING': {
      return {
        ...state,
        fetching: false,
        fetched: true,
      }
    }
    case 'GET_PAGE_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
      }
    }
    case 'GET_BLU_PAGES_FULFILLED': {
      return {
        ...state,
        bluPages: action.payLoad,
      }
    }
    case 'GET_BLU_PAGE_PENDING': {
      return {
        ...state,
      }
    }
    case 'DELETE_PAGE_FULFILLED': {
      const newState = {...state};
      newState.pages['Content'] = newState.pages['Content'].filter(page => {
        return page.id !== action.payLoad.id
      });
      return newState;
    }
    case 'SET_PAGE_NAME_TAKEN':
      return {
        ...state, pageNameTaken: true,
      };
    case 'SET_PAGE_NAME_NOT_TAKEN':
      return {
        ...state, pageNameTaken: false,
      };
    case 'GET_PAGES_REJECTED': {
      // return {...state, errors: action.payLoad.errors}
    }
    default:
  }

  return {...state};
}
  


// WEBPACK FOOTER //
// ./src/reducers/pagesReducer.js